<template>
  <div class="container container--employee employee-orders mb-4 employee-orders-catalog">
    <BackToAuctionsCatalogsLink :routeName="'employeesFinishedAuctionsCatalogs'" />
    <InternetAuctionsCatalogHeader
      v-if="isInternetType"/>
    <AuctionsCatalogHeader
      v-else/>
    <router-view></router-view>
  </div>
</template>

<script>
  import AuctionsCatalogHeader from './../auctions_catalog_header';
  import InternetAuctionsCatalogHeader from './internet/auctions_catalog_header';
  import BackToAuctionsCatalogsLink from './../back_to_auctions_catalogs_link';

  export default {
    name: 'FinishedAuctionsCatalog',
    components: {
      AuctionsCatalogHeader,
      InternetAuctionsCatalogHeader,
      BackToAuctionsCatalogsLink,
    },
    computed: {
      isInternetType() {
        return this.$route.params.auctionType === 'internet';
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/finished/auctions_catalog.vue?66576646